module.exports = __webpack_public_path__ + "img/0dfa0b4b-7722-40f4-9bc0-7bbf9bb1c000.06c8f305.webp";